/**
 * Canonical lifecycle / status strings for staff + golfer UI.
 * Source of truth for wording: `docs/design/UI_TERMINOLOGY_GLOSSARY.md` (Phase 4).
 */
/** Normalize API enums / snake values for lookup (hyphen-lowercase keys). */
export function normalizeStatusKey(raw) {
    return raw.trim().toLowerCase().replace(/_/g, '-');
}
/**
 * Multi-word title case with underscores treated as spaces.
 * Empty input yields em dash — matches legacy golfer dashboard formatting.
 */
export function titleCaseDashboardWords(value) {
    const t = (value ?? '').replace(/_/g, ' ').trim();
    if (!t)
        return '—';
    return t
        .split(/\s+/)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');
}
const CANONICAL_UI_STATUS_LABELS = {
    canceled: 'Canceled',
    cancelled: 'Canceled',
    reserved: 'Reserved',
    confirmed: 'Confirmed',
    completed: 'Completed',
    pending: 'Pending',
    paid: 'Paid',
    partial: 'Partial',
    'checked-in': 'Checked In',
    'no-show': 'No Show',
    deleted: 'Deleted',
    active: 'Active',
    draft: 'Draft',
    closed: 'Closed',
    inactive: 'Inactive',
    expired: 'Expired',
    suspended: 'Suspended',
    depleted: 'Depleted',
    archived: 'Archived',
    issued: 'Issued',
    open: 'Open',
    frozen: 'Frozen',
    wallet: 'Wallet',
    credit: 'Credit',
};
/** Returns glossary-aligned label or `null` when unknown — callers supply fallback. */
export function canonicalStatusDisplayLabel(raw) {
    const k = normalizeStatusKey(raw);
    return CANONICAL_UI_STATUS_LABELS[k] ?? null;
}
//# sourceMappingURL=canonical-status-label.js.map